var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"analyze"},[_c('today-info',{attrs:{"data":_vm.data,"type":_vm.type}}),_c('history',{attrs:{"data":_vm.data,"type":_vm.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }